// the purpose of this file is to be called from any applicable function to log an activity to the Firestore database. This function will be used to log activities such as user sign-ins, post creations, and other user interactions.
// whatever user is logged in will be the one who's activity is logged-- placed into a sub-collection of the user's document in the Firestore database.
// logs will hold the following fields:
// - activity: the type of activity being logged (e.g., 'sign_in', 'post', 'like', 'comment')
// - timestamp: the timestamp of the activity
// - interacted_with: the ID of the document that the user interacted with (e.g., post ID, user ID)
// - additional_data: any additional data related to the activity
//
// the function will take the following parameters:
// - activity: the type of activity being logged
// - interactedWith: the ID of the document that the user interacted with
// - additionalData: any additional data related to the activity
// - user: the user object of the user who performed the activity
// 
// the function will return a Promise that resolves when the activity is successfully logged to the Firestore database

import { db } from "../firebase";
import { serverTimestamp } from "firebase/firestore";
import { collection, addDoc } from "firebase/firestore";
import { getDocs, updateDoc } from "firebase/firestore";

export async function logActivity(activity, interactedWith, additionalData, user) {
    // Get a Firestore reference to the user's activities collection
    const activitiesRef = collection(db, 'users', user.uid, 'activities');
    
    // check if that activity already exists
    // if it does, update the timestamp
    // if it doesn't, create a new activity document
    // Check if the activity already exists
    const querySnapshot = await getDocs(activitiesRef);
    const existingActivity = querySnapshot.docs.find(doc => doc.data().interacted_with === interactedWith);

    if (existingActivity) {
        // Update the timestamp of the existing activity
        await updateDoc(existingActivity.ref, { timestamp: serverTimestamp() });
    } else {
        // Create a new activity document

        const newActivity = {
            activity,
            timestamp: serverTimestamp(),
            interacted_with: interactedWith,
            additional_data: additionalData,
        };

        try {
            // Add the new activity document to the activities collection
            await addDoc(activitiesRef, newActivity);
            console.log('Activity logged successfully:', newActivity);
        } catch (error) {
            console.error('Error logging activity:', error);
            throw error; // pass to parent function
        }
    }

}



